import { View, Text } from 'react-native';
import gs from '../../../styles/globalStyles';
import classes from '../../../styles/globalClasses';
import NeedHelp from '../../../sharedComponents/NeedHelp/NeedHelp';
import BackButton from '../../../sharedComponents/BackButton/BackButton';
import { PrivateStackParamList } from '../../../navigationApp/types';
import { NativeStackNavigationProp, NativeStackScreenProps } from '@react-navigation/native-stack';
import { ThemedView } from '@app/theme';


type NavigationProp = NativeStackNavigationProp<
  PrivateStackParamList,
  'INTEREST_CALCULATOR'
>;

const InterestCalculatorHeader = ({ navigation } :  { navigation : NavigationProp} ) => {
  return (
    <ThemedView
      backgroundColor="bg-fill-primary"
      style={[
        gs.flexRow,
        gs.spaceBetween,
        gs.setPaddingHorizontal(16),
        gs.setHeight(60),
        gs.alignItemsCenter,
        {
          borderBottomColor:'#e4e7ec',
          borderBottomWidth:1,
        }
      ]}>
      <View style={[gs.flexRow]}>
        <BackButton navigation={navigation} />
      </View>
      <NeedHelp />
    </ThemedView>
  );
};

export default InterestCalculatorHeader;
